/**
 * Steuert das Mobile-Menue (Hamburger -> Drawer) des Custom Headers.
 *
 * Event-Delegation auf document statt gecachter Element-Referenzen:
 * Die fruehere Custom-Element-Variante hat ihre Kind-Elemente im
 * Constructor gesucht, bevor der per createElement erzeugte Wrapper
 * Kinder hatte — dadurch wurde der Toggle-Listener nie registriert
 * und das Menue blieb auf Mobilgeraeten tot. Delegation ist vom
 * Lade-Zeitpunkt unabhaengig und ueberlebt Section-Rerenders im
 * Theme-Editor.
 */
(() => {
  const OPEN_CLASS = 'custom-header-drawer--open';

  const getDrawer = () => document.getElementById('mobile-menu');
  const getToggle = () => document.querySelector('.custom-header__mobile-toggle');

  const isOpen = () => {
    const drawer = getDrawer();
    return Boolean(drawer && drawer.classList.contains(OPEN_CLASS));
  };

  const openMenu = () => {
    const drawer = getDrawer();
    if (!drawer) return;
    drawer.classList.add(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'false');
    getToggle()?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('.custom-header-drawer__close')?.focus();
  };

  const closeMenu = ({ restoreFocus = true } = {}) => {
    const drawer = getDrawer();
    if (!drawer) return;
    const toggle = getToggle();
    // Fokus muss den Drawer verlassen, bevor er aria-hidden wird
    if (restoreFocus) toggle?.focus();
    drawer.classList.remove(OPEN_CLASS);
    drawer.setAttribute('aria-hidden', 'true');
    toggle?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  };

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    if (target.closest('.custom-header__mobile-toggle')) {
      isOpen() ? closeMenu() : openMenu();
      return;
    }

    if (
      target.closest('.custom-header-drawer__close') ||
      target.closest('.custom-header-drawer__overlay')
    ) {
      closeMenu();
      return;
    }

    // Navigations-Klick im Drawer: schliessen, aber Fokus nicht zurueckholen,
    // damit Anker-Spruenge nicht wieder nach oben scrollen
    if (
      target.closest(
        'a.custom-header-drawer__menu-link, .custom-header-drawer__submenu-link, .custom-header-drawer__utility-link'
      )
    ) {
      closeMenu({ restoreFocus: false });
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) closeMenu();
  });

  // Theme-Editor: Nach einem Section-Rerender startet der Drawer
  // geschlossen — ein evtl. gesetzter Scroll-Lock muss dann weg
  document.addEventListener('shopify:section:load', () => {
    if (!isOpen()) document.body.style.overflow = '';
  });
})();
